import React from 'react'
import DashboardAlerts from './DashboardAlerts'
import DashboardContainer from './DashboardContainer'
import DashboardDialogs from './DashboardDialogs'
import { AlertInput } from 'src/components/common/Alert'

export type DashboardShellProps = {
  children: React.ReactNode
  rateAlert: AlertInput
  listAlert: AlertInput
  onCloseRateAlert: () => void
  onCloseListAlert: () => void
  mode: 'single' | 'multi' | 'host' | undefined | undefined
  fullScreen: boolean
  gameState: string
  musicIsPlaying: boolean
  volumeExpanded: boolean
  volumeLevel: number
  appUserId?: number
  avatarMenuAnchorEl: HTMLElement | null
  avatarMenuOpen: boolean
  onTitleClick: () => void
  onToggleMusic: () => void
  onExpandVolume: (expanded: boolean) => void
  onVolumeChange: (value: number) => void
  onAvatarMenuClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  onAvatarMenuClose: () => void
  onLogin: () => void
  onAccount: () => void
  showAdminOption?: boolean
  onAdmin?: () => void
  onLogout: () => void
  showEmojiPreview: boolean
  showHowToPlay: boolean
  selectedPlayer?: { id?: number; name?: string }
  onCloseEmoji: () => void
  onCloseHowToPlay: () => void
  onChangeIcon: (playerId: number | undefined, emoji: string) => void
  sounds?: { click: () => void; swipe: () => void }
}

const DashboardShell: React.FC<DashboardShellProps> = ({
  children,
  rateAlert,
  listAlert,
  onCloseRateAlert,
  onCloseListAlert,
  mode,
  fullScreen,
  gameState,
  musicIsPlaying,
  volumeExpanded,
  volumeLevel,
  appUserId,
  avatarMenuAnchorEl,
  avatarMenuOpen,
  onTitleClick,
  onToggleMusic,
  onExpandVolume,
  onVolumeChange,
  onAvatarMenuClick,
  onAvatarMenuClose,
  onLogin,
  onAccount,
  showAdminOption,
  onAdmin,
  onLogout,
  showEmojiPreview,
  showHowToPlay,
  selectedPlayer,
  onCloseEmoji,
  onCloseHowToPlay,
  onChangeIcon,
  sounds,
}) => {
  return (
    <div
      style={{
        minHeight: mode === 'single' && fullScreen ? '100dvh' : '100vh',
      }}
    >
      <DashboardAlerts
        rateAlert={rateAlert}
        listAlert={listAlert}
        onCloseRate={onCloseRateAlert}
        onCloseList={onCloseListAlert}
      />
      <img id="pencilImg" src="trophy.png" alt="" style={{ display: 'none' }} />
      <DashboardContainer
        mode={mode}
        fullScreen={fullScreen}
        gameState={gameState}
        musicIsPlaying={musicIsPlaying}
        volumeExpanded={volumeExpanded}
        volumeLevel={volumeLevel}
        appUserId={appUserId}
        avatarMenuAnchorEl={avatarMenuAnchorEl}
        avatarMenuOpen={avatarMenuOpen}
        onTitleClick={onTitleClick}
        onToggleMusic={onToggleMusic}
        onExpandVolume={onExpandVolume}
        onVolumeChange={onVolumeChange}
        onAvatarMenuClick={onAvatarMenuClick}
        onAvatarMenuClose={onAvatarMenuClose}
        onLogin={onLogin}
        onAccount={onAccount}
        showAdminOption={showAdminOption}
        onAdmin={onAdmin}
        onLogout={onLogout}
      >
        {children}
      </DashboardContainer>
      <DashboardDialogs
        fullScreen={fullScreen}
        showEmojiPreview={showEmojiPreview}
        showHowToPlay={showHowToPlay}
        selectedPlayer={selectedPlayer}
        onCloseEmoji={onCloseEmoji}
        onCloseHowToPlay={onCloseHowToPlay}
        onChangeIcon={onChangeIcon}
        sounds={sounds}
      />
    </div>
  )
}

export default DashboardShell
